import { DateRange } from "react-day-picker";

import { useLatePayments } from "~/pages/payments/hooks/useLatePayments";
import { useOutstandingPayments } from "~/pages/payments/hooks/useOutstandingPayments";
import { usePaymentStats } from "~/pages/payments/hooks/usePaymentStats";
import { usePaymentsData } from "~/pages/payments/hooks/usePaymentsData";

export const usePaymentsSummary = (dateRange?: DateRange) => {
  // Get payments data without pagination for stats calculation
  const { payments, hasDateFilter } = usePaymentsData(dateRange);
  const { stats } = usePaymentStats(dateRange, payments);
  const {
    outstandingPayments,
    isLoadingOutstandingPayments,
    totalOutstandingPayments,
  } = useOutstandingPayments(dateRange);
  const {
    latePayments,
    isLoadingLatePayments,
    totalLatePayments,
    getLatenessSeverity,
    mapSeverity,
  } = useLatePayments(dateRange);

  return {
    stats,
    latePayments,
    isLoadingLatePayments,
    outstandingPayments,
    isLoadingOutstandingPayments,
    totalLatePayments,
    totalOutstandingPayments,
    getLatenessSeverity,
    mapSeverity,
    hasDateFilter,
  };
};
